import React, { useState } from 'react'
import { Modal, Select, Spin, message } from 'antd'
import { api } from '../../../../../services'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

const { Option } = Select

const ShareModal = ({ visible, item = {}, onCancel }) => {
  const { t } = useTranslation()
  const user = useSelector(state => state.user || {})
  const [emailList, setEmailList] = useState([])
  const [selectedValue, setSelectedValue] = useState([])
  const [fetching, setFetching] = useState(false)
  const [okLoading, setOkLoading] = useState(false)
  const [tempData, setTempData] = useState([])

  const fetchUserEmails = value => {
    let active_organization_id = null
    if (
      user &&
      typeof user === 'object' &&
      user.info &&
      typeof user.info === 'object'
    ) {
      active_organization_id = user.info.active_organization_id
    }
    if (!active_organization_id) {
      message.error('No active organization ID found for user.')
      return
    }
    setEmailList([])
    setTempData([])
    setFetching(true)
    api.organizations
      .getUsersByOrganizationId(active_organization_id)
      .then(res => {
        const tempArr = []
        const emailArr = []
        res.data.forEach(val => {
          if (val.user) {
            tempArr.push({
              id: val.user.id,
              email: val.user.email,
              username: val.user.username
            })
            if (val.user.email.includes(value)) {
              emailArr.push({
                text: val.user.email,
                value: val.user.email
              })
            }
          }
        })
        setTempData(tempArr)
        setEmailList(emailArr)
        setFetching(false)
      })
      .catch(() => setFetching(false))
  }

  const handleChange = selected => {
    setSelectedValue(selected)
  }

  const handleOk = () => {
    setOkLoading(true)
    let tempEmails = []
    selectedValue.forEach(element => {
      let obj = tempData.find(o => o.email === element.label)
      if (obj !== undefined) {
        tempEmails.push({
          user_id: obj.id,
          email: obj.email,
          username: obj.username
        })
      }
    })
    const data = {
      filename: item.filename,
      public: item.is_public,
      emails: tempEmails,
      media_data_id: item.id,
      path: item.path
    }
    api.library
      .sharePdf(data)
      .then(res => {
        if (res.status === 200) {
          message.success(t('v4:shared_file'))
          handleClose()
        }
      })
      .catch(() => {
        message.error(t('v4:error_shared_file'))
      })
      .finally(() => {
        setOkLoading(false)
      })
  }

  // Clear selectedValue and call onCancel
  const handleClose = () => {
    setSelectedValue([])
    if (typeof onCancel === 'function') onCancel()
  }

  const safeItem = item || {}
  return (
    <Modal
      title={
        safeItem.media_format === 'TEXT'
          ? t('v4:share_text_title_txt')
          : t('v4:share_text_title')
      }
      visible={visible}
      onOk={handleOk}
      onCancel={handleClose}
      okText={t('v4:share')}
      okButtonProps={{ loading: okLoading }}
      cancelButtonProps={{ disabled: okLoading }}
      afterClose={() => setSelectedValue([])}
    >
      <p>
        {t('v4:share_text')} <b>{safeItem.filename}</b>
      </p>

      <Select
        mode="multiple"
        labelInValue
        value={selectedValue}
        placeholder={t('v4:select_users')}
        notFoundContent={fetching ? <Spin size="small" /> : null}
        filterOption={false}
        onSearch={fetchUserEmails}
        onFocus={() => {
          if (emailList.length === 0) fetchUserEmails('')
        }}
        onChange={handleChange}
        style={{ width: '100%' }}
      >
        {emailList.map(d => (
          <Option key={d.value}>{d.text}</Option>
        ))}
      </Select>
    </Modal>
  )
}

export default ShareModal
